import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import $ from 'jquery';
import NavView from '../component/NavView';
import PageFooter from './PageFooter';
import SectionView from '../component/home/SectionView';
import AboutSectionView from '../component/home/AboutSectionView';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';
import { getImgPath } from '../store/JSTool';
import NavViewMobile from '../mobile/component/NavViewMobile';

export default function RecruitPage() {

    let navId = 'recruit_us_page_nav';
    let pageId = 'recruit_us_page_div';
    let sectionIdAry = ['recruit_us_news', 'recruit_us_office', 'recruit_us_workspace'];
    const settingData = useSelector(state => state.settingData);

    React.useEffect(() => {
        JSTool.addPageScrollListener(pageId, navId, 0, sectionIdAry);
    }, []);

    return (
        <Stack component={'div'}
            sx={{
                width: 1,
                height: '100vh',
                position: 'relative',
            }}>
            {settingData.isMobile && <NavViewMobile navId={navId} pageId={pageId} />}
            {!settingData.isMobile && <NavView navId={navId} pageId={pageId} />}

            <Stack
                id={pageId}
                component={'div'}
                sx={{
                    width: 1,
                    overflow: 'auto',
                    position: 'relative',
                    alignItems: 'center',
                    minHeight: '100vh',
                }} >

                <Stack sx={{
                    width: 1,
                    bgcolor: 'black',
                }}>
                    <Box
                        component={'img'}
                        src={getImgPath('apj_banner_1.png')}
                        sx={{
                            opacity: 0.5,
                            width: 1,
                            maxHeight: settingData.isMobile ? '200px' : '300px',
                            minHeight: settingData.isMobile ? '100px' : '150px',
                            objectFit: 'cover',
                        }} />
                </Stack>

                <Typography sx={{
                    fontSize: settingData.isMobile ? 12 : 16,
                    fontWeight: 600,
                    width: settingData.isMobile ? 0.9 : '1100px',
                    mt: 3,
                    mb: 1,
                    fontFamily: settingData.fontFM,
                    textAlign: !settingData.isMobile && 'justify',
                }}>
                    <span style={{
                        fontSize: settingData.isMobile ? 18 : 23,
                    }}>
                        {settingData.langDic['lang29']}</span> <br />
                    {settingData.langDic['lang30']}
                </Typography>


                <SectionView id={sectionIdAry[0]} title='Join Us' />

                <Stack sx={{
                    flexDirection: settingData.isMobile ? 'column' : 'row',
                    alignItems: 'center',
                    my: settingData.isMobile ? 2 : 3,
                }}>
                    <Typography sx={{
                        fontSize: settingData.isMobile ? 18 : 22,
                        fontFamily: settingData.fontFM,
                    }}>
                        {settingData.langDic['lang31']}
                    </Typography>

                    <Stack sx={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        my: settingData.isMobile ? 2 : 3,
                    }}>
                        <Box
                            component={'img'}
                            src={getImgPath('email_img2.png')}
                            sx={{
                                height: settingData.isMobile ? '40px' : '50px',
                                mx: 2,
                            }} />

                        <a style={{
                            color: 'black',
                            fontSize: settingData.isMobile ? 18 : 22,
                            fontFamily: 'Lexend Deca',
                        }} href="mailto:li.yi@aplusjapan.co.jp">li.yi@aplusjapan.co.jp</a>

                        <Typography sx={{
                            display: settingData.lang == 'jp' ? 'flex' : 'none',
                            fontSize: settingData.isMobile ? 18 : 22,
                            fontFamily: settingData.fontFM,
                            ml: 1,
                        }}>
                            まで
                        </Typography>
                    </Stack>

                </Stack>

                <SectionView id={sectionIdAry[1]} title='Our Office' />
                <AddInfo index={0} title={settingData.langDic['lang16']} detail={settingData.langDic['lang26']} />
                <AddInfo index={1} title={settingData.langDic['lang27']} detail={settingData.langDic['lang28']} />
                <AddInfo index={2} title='A PLUS ENTERTAINMENT PTE. LTD.' detail='12 Woodlands Square #10-73 Woods Square, Singapore' />

                <SectionView id={sectionIdAry[2]} title='Workplace' />
                <ImageItem title='Meeting Room' imgName='place_0.jpg' />
                <ImageItem title='Game Room' imgName='place_1.jpg' />
                <ImageItem title='Leisure Area' imgName='place_2.jpg' />

                <Box sx={{ flex: 1, mt: 3 }} />
                <Box
                    id='apj_logo_id'
                    component={'img'}
                    src={getImgPath('logo_black.png')}
                    sx={{
                        display: !settingData.isMobile && 'none',
                        opacity: 0,
                        mb: 3,
                        width: 0.4,
                    }} />
                <PageFooter pageId={pageId} />
            </Stack>
        </Stack>
    );
}

function AddInfo(props) {
    const settingData = useSelector(state => state.settingData);

    function tap() {
        if (props.index == 0) {
            window.open("https://www.google.com/maps/place/KDX%E8%A5%BF%E6%96%B0%E6%A9%8B%E3%83%93%E3%83%AB/@35.665787,139.7385569,14.71z/data=!3m1!5s0x60188b9493b8cba1:0xbff20aaf923cfa64!4m6!3m5!1s0x60188b18d6dba76b:0xb0dce2fbf788dd82!8m2!3d35.6652115!4d139.7507033!16s%2Fg%2F11q57tpw7m?entry=ttu&g_ep=EgoyMDI0MTEwNS4wIKXMDSoASAFQAw%3D%3D");

        } else if (props.index == 1) {
            window.open("https://www.google.com/maps/place/%E5%85%AD%E5%85%AB%E5%85%AB%E5%B9%BF%E5%9C%BA/@31.2316007,121.4620626,17z/data=!4m6!3m5!1s0x35b270144600a3bd:0xdaaa2d264d0d8610!8m2!3d31.231408!4d121.464541!16s%2Fg%2F11cm1j6fw7?entry=ttu");

        } else if (props.index == 2) {
            window.open("https://www.google.com/maps/place/Woodlands+Square,+%E6%96%B0%E5%8A%A0%E5%9D%A1/@1.4383392,103.7643638,14z/data=!4m6!3m5!1s0x31da13a8888377d1:0xdd95aae21ea2565f!8m2!3d1.4364417!4d103.7849068!16s%2Fg%2F1td0qd7m?entry=ttu");
        }
    }

    return (
        <Stack
            onClick={tap}
            sx={{
                flexDirection: settingData.isMobile ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: 'center',
                my: 2,
                cursor: 'pointer',
            }}>
            <Stack>
                <Typography sx={{
                    fontSize: settingData.isMobile ? 18 : 22,
                    fontFamily: settingData.fontFM,
                    textAlign: settingData.isMobile && 'center'
                }}>
                    {props.title}
                </Typography>

                {/* 右边 */}
                <Stack sx={{
                    flexDirection: settingData.isMobile ? 'column' : 'row',
                    mt: 1,
                    width: settingData.isMobile ? 1 : '550px',
                    alignItems: 'center',
                }}>
                    <Typography sx={{
                        width: '120px',
                        minWidth: '120px',
                        bgcolor: '#FFC714',
                        color: 'white',
                        textAlign: 'center',
                        height: '25px',
                        lineHeight: '25px',
                        borderRadius: '4px',
                        fontFamily: 'Lexend Deca',
                        fontSize: 13
                    }}>
                        Location
                    </Typography>


                    <Typography sx={{
                        fontFamily: settingData.fontFM,
                        ml: 2,
                        fontSize: 13,
                        mt: settingData.isMobile && 1.5,
                        mb: settingData.isMobile && 0.5,
                    }}>
                        {props.detail}
                    </Typography>
                </Stack>
            </Stack>

            <Box
                component={'img'}
                src={getImgPath(`add_${props.index}.png`)}
                sx={{
                    height: '120px',
                    ml: 3,
                }} />

        </Stack>
    );
}

function ImageItem(props) {
    const settingData = useSelector(state => state.settingData);

    return (
        <Stack sx={{
            alignItems: 'center',
            position: 'relative',
            width: settingData.isMobile ? 1 : 'auto',
            my: 1,
        }}>
            <Box
                component={'img'}
                src={getImgPath(props.imgName)}
                sx={{
                    height: settingData.isMobile ? '160px' : '350px',
                    width: settingData.isMobile ? 0.9 : '800px',
                    objectFit: 'cover',
                    borderRadius: '10px',
                }} />

            <Typography sx={{
                bgcolor: '#00000099',
                borderRadius: '6px',
                color: 'white',
                width: settingData.isMobile ? '100px' : '150px',
                textAlign: 'center',
                py: 0.5,
                fontSize: settingData.isMobile ? 10 : 15,
                fontWeight: 'bold',
                position: 'absolute',
                top: '15px',
                right: '35px',
            }}>
                {props.title}
            </Typography>

        </Stack>
    );
}